var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path0, _path1, _path10, _polygon, _g, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 220.56 54.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#38a6de;}.cls-2{fill:#18508d;}.cls-3{fill:none;}.cls-4{fill:#fff;}.cls-5{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-3.08 -1.12)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.44 41.84 49.47 15.4 23.67 34.99 21.44 41.84"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.43,19a4.45,4.45,0,0,0-2.1-1.45,7.43,7.43,0,0,0-2.52-.47,6.53,6.53,0,0,0-1.43.16,5.65,5.65,0,0,0-1.39.51,3.05,3.05,0,0,0-1.06.92,2.35,2.35,0,0,0-.41,1.39,2.31,2.31,0,0,0,1,2A9.24,9.24,0,0,0,69,23.29c1,.33,2.06.65,3.21,1a13.26,13.26,0,0,1,3.2,1.39,7.61,7.61,0,0,1,2.48,2.41,7.4,7.4,0,0,1,1,4,9.29,9.29,0,0,1-.9,4.21,8.54,8.54,0,0,1-2.43,3A10.41,10.41,0,0,1,72,41.07a16.31,16.31,0,0,1-9.5-.29A13.09,13.09,0,0,1,58,38l4.54-5A6.66,6.66,0,0,0,65,35a7,7,0,0,0,3.09.72,7.16,7.16,0,0,0,1.57-.19A5.19,5.19,0,0,0,71.06,35a3.18,3.18,0,0,0,1-.94,2.33,2.33,0,0,0,.39-1.35,2.43,2.43,0,0,0-1-2.06A9.08,9.08,0,0,0,69,29.38c-1-.35-2.1-.71-3.27-1.06a14.59,14.59,0,0,1-3.27-1.43,7.92,7.92,0,0,1-2.52-2.37,6.88,6.88,0,0,1-1-3.89,8.55,8.55,0,0,1,3.37-7,10.82,10.82,0,0,1,3.54-1.78,14.62,14.62,0,0,1,4.13-.59,16,16,0,0,1,4.74.7,11,11,0,0,1,4.13,2.33Z",
    transform: "translate(-3.08 -1.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.55,37.47a9.69,9.69,0,0,1-3.72,2.9,11.17,11.17,0,0,1-4.66,1,12.51,12.51,0,0,1-4.31-.74,10.33,10.33,0,0,1-3.52-2.11A9.79,9.79,0,0,1,80,35.26a11.13,11.13,0,0,1,0-8.58,9.89,9.89,0,0,1,2.35-3.29,10.47,10.47,0,0,1,3.52-2.1,12.51,12.51,0,0,1,4.31-.74,9.8,9.8,0,0,1,3.86.74A8,8,0,0,1,97,23.39a9.37,9.37,0,0,1,1.86,3.29A13.14,13.14,0,0,1,99.49,31v1.92H85.26a4.83,4.83,0,0,0,1.6,2.8,4.48,4.48,0,0,0,3,1.05,4.63,4.63,0,0,0,2.56-.68,7,7,0,0,0,1.82-1.74Zm-5.19-8.75a3.59,3.59,0,0,0-1-2.65A3.64,3.64,0,0,0,89.6,25a4.48,4.48,0,0,0-3.13,1.17,3.81,3.81,0,0,0-.86,1.18,4.06,4.06,0,0,0-.35,1.41Z",
    transform: "translate(-3.08 -1.12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.59,27.46a3.42,3.42,0,0,0-1.27-1.09,3.78,3.78,0,0,0-1.76-.42A4.66,4.66,0,0,0,107,27.34,5.1,5.1,0,0,0,105.66,31,5.14,5.14,0,0,0,107,34.61,4.66,4.66,0,0,0,110.56,36a3.29,3.29,0,0,0,1.76-.45,5.47,5.47,0,0,0,1.27-1.06l4,4.25a7.8,7.8,0,0,1-3.38,2.06,12.33,12.33,0,0,1-8-.14,10.19,10.19,0,0,1-3.51-2.11,9.65,9.65,0,0,1-2.35-3.29A10.28,10.28,0,0,1,99.53,31a10.28,10.28,0,0,1,.86-4.29,9.75,9.75,0,0,1,2.35-3.29,10.33,10.33,0,0,1,3.51-2.1,12.55,12.55,0,0,1,4.31-.74,12.78,12.78,0,0,1,3.7.59,7.92,7.92,0,0,1,3.38,2.07Z",
    transform: "translate(-3.08 -1.12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.91,40.91H130v-2.7h-.08a6.93,6.93,0,0,1-.84,1.14,5.56,5.56,0,0,1-1.25,1,7.28,7.28,0,0,1-1.67.74,7.05,7.05,0,0,1-2.05.29,8.55,8.55,0,0,1-3.78-.72,5.47,5.47,0,0,1-2.24-2,7.71,7.71,0,0,1-1.07-3,25.25,25.25,0,0,1-.26-3.72V21h6.13v9.73c0,.57,0,1.16.06,1.78a5.35,5.35,0,0,0,.37,1.69,2.85,2.85,0,0,0,.94,1.27,2.9,2.9,0,0,0,1.82.49,3.74,3.74,0,0,0,1.92-.43,2.92,2.92,0,0,0,1.12-1.14,4.66,4.66,0,0,0,.51-1.62,14.15,14.15,0,0,0,.12-1.88V21h6.14Z",
    transform: "translate(-3.08 -1.12)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.17,21h6.13v3.19h.08a7.63,7.63,0,0,1,2.33-2.76,5.92,5.92,0,0,1,3.4-.92c.35,0,.71,0,1.06,0a5.73,5.73,0,0,1,1,.16v5.6a10.42,10.42,0,0,0-1.29-.3,8.07,8.07,0,0,0-1.33-.1,6.42,6.42,0,0,0-2.77.49,3.6,3.6,0,0,0-1.58,1.37,5.12,5.12,0,0,0-.71,2.1,20.34,20.34,0,0,0-.17,2.7v8.3h-6.13Z",
    transform: "translate(-3.08 -1.12)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.81,37.47a9.69,9.69,0,0,1-3.72,2.9,11.17,11.17,0,0,1-4.66,1,12.51,12.51,0,0,1-4.31-.74,10.33,10.33,0,0,1-3.52-2.11,9.79,9.79,0,0,1-2.35-3.29,11.13,11.13,0,0,1,0-8.58,9.89,9.89,0,0,1,2.35-3.29,10.47,10.47,0,0,1,3.52-2.1,12.51,12.51,0,0,1,4.31-.74,9.8,9.8,0,0,1,3.86.74,8,8,0,0,1,2.94,2.1,9.37,9.37,0,0,1,1.86,3.29,13.14,13.14,0,0,1,.66,4.29v1.92H155.52a4.83,4.83,0,0,0,1.6,2.8,4.48,4.48,0,0,0,3,1.05,4.63,4.63,0,0,0,2.56-.68,7,7,0,0,0,1.82-1.74Zm-5.19-8.75a3.59,3.59,0,0,0-1-2.65A3.64,3.64,0,0,0,159.86,25a4.48,4.48,0,0,0-3.13,1.17,3.81,3.81,0,0,0-.86,1.18,4.06,4.06,0,0,0-.35,1.41Z",
    transform: "translate(-3.08 -1.12)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.16,12.51H189.1V15.7H174.59v9.56h13.49v3.19H174.59v13h-3.43Z",
    transform: "translate(-3.08 -1.12)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189,24.77a9,9,0,0,1,3.49-2.22,12.19,12.19,0,0,1,4.11-.72c2.83,0,4.88.67,6.13,2s1.88,3.37,1.88,6.09v8.22c0,.54,0,1.11.08,1.7s.12,1.12.21,1.61h-3.07a6.46,6.46,0,0,1-.18-1.45c0-.53,0-1,0-1.41h-.09A7.44,7.44,0,0,1,199,41a7.21,7.21,0,0,1-3.78.94,9.85,9.85,0,0,1-2.76-.37,6.72,6.72,0,0,1-2.25-1.08,5.36,5.36,0,0,1-1.53-1.78,5.09,5.09,0,0,1-.57-2.45,5.36,5.36,0,0,1,1.22-3.72,7.42,7.42,0,0,1,3-2,14.83,14.83,0,0,1,3.92-.82c1.41-.11,2.69-.16,3.87-.16h1.22V29a3.88,3.88,0,0,0-1.24-3.14,5.25,5.25,0,0,0-3.5-1.07,9.28,9.28,0,0,0-3,.51A7.38,7.38,0,0,0,191,26.86Zm9.23,7.48a11.47,11.47,0,0,0-4.86.86,2.91,2.91,0,0,0-1.8,2.82,2.78,2.78,0,0,0,1.21,2.56,5.56,5.56,0,0,0,3,.75,5.73,5.73,0,0,0,2.43-.47,5.09,5.09,0,0,0,1.74-1.24A5.41,5.41,0,0,0,201,35.71a7.41,7.41,0,0,0,.41-2.23V32.25Z",
    transform: "translate(-3.08 -1.12)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.29,31.15l-6.86-8.83h4.17l5.06,6.87,4.79-6.87h3.88l-6.58,8.83,7.89,10.3h-4.21l-6.05-8.26-6,8.26h-4Z",
    transform: "translate(-3.08 -1.12)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25.29,
    cy: 25.29,
    r: 25.29
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4,7.22H52.52V55.79H4Z",
    transform: "translate(-3.08 -1.12)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.24,9.24,10,17.34V29.48c0,11.23,7.77,21.74,18.22,24.29,10.44-2.55,18.21-13.06,18.21-24.29V17.34Z",
    transform: "translate(-3.08 -1.12)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.4,29.48c0,9.15-6,17.59-14.16,20.1-8.14-2.51-14.17-10.95-14.17-20.1V20l14.17-6.3L42.4,20Z",
    transform: "translate(-3.08 -1.12)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.36 40.73 46.39 14.29 20.59 33.88 18.36 40.73"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.83,
    y: 16.08,
    width: 29.24,
    height: 25.09,
    transform: "translate(-4.39 0.58) rotate(-2.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61l-.6-12.68-1,.05a33,33,0,0,1,8-10.75l0,1,22.06-1,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61,20.53,26l-.7,0A32.86,32.86,0,0,1,27.74,15.4l0,.86,21.84-1,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61l-.59-12.48-.43,0A32.7,32.7,0,0,1,28,15.56l0,.69,21.63-1,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61l-.59-12.39h-.15a32.31,32.31,0,0,1,7.79-10.5l0,.51,21.42-1,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61l-.3-6.36-.21-4.5-.56,0c.19-.49.39-1,.61-1.46A32,32,0,0,1,28.4,15.9l0,.33,21.2-1,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61l-.3-6.31-.14-3-.87,0A26.26,26.26,0,0,1,21,26.4a31.8,31.8,0,0,1,7.66-10.34v.16l21-1,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61l-.3-6.26-.14-3-.58,0a28,28,0,0,1,1.13-2.92,31.66,31.66,0,0,1,7.6-10.25c.41-.37.83-.74,1.26-1.09l0,1,19.47-.92,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61l-.3-6.21-.14-3-.29,0a26.57,26.57,0,0,1,1.12-2.89,31.5,31.5,0,0,1,7.54-10.18c.41-.37.83-.73,1.25-1.08l0,.83,19.27-.91,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61l-.29-6.16-.93,0a26.74,26.74,0,0,1,1.89-5.84,31,31,0,0,1,7.49-10.09c.4-.37.81-.72,1.23-1.07l0,.64,19.07-.9,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,38.61l-.29-6.11-.63,0a26.9,26.9,0,0,1,1.87-5.8,30.87,30.87,0,0,1,7.43-10c.4-.36.81-.71,1.23-1.06l0,.46,18.86-.89,1.2,25.39L21.29,42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.05,38.66c-.39-8.31,3.34-16,9.68-21.77.39-.36.8-.71,1.22-1.06v.28l18.66-.88,1.2,25.39L21.29,42l-.16-3.4Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.36,38.64C20,30.41,23.66,22.76,30,17.06c.79-.72,1.61-1.4,2.48-2l0,1,17.15-.81,1.2,25.39L21.29,42l-.16-3.4Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.66,38.63c-.39-8.17,3.28-15.75,9.51-21.41.78-.71,1.6-1.38,2.46-2l0,.84,16.95-.8,1.2,25.39L21.29,42l-.16-3.4Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,38.62c-.38-8.1,3.25-15.62,9.43-21.23.77-.7,1.59-1.38,2.44-2l0,.64,16.76-.79,1.2,25.39L21.53,42l0,1.06c-.12-.48-.21-1-.3-1.45A24.63,24.63,0,0,1,21,38.62Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.26,38.6c-.38-8,3.22-15.48,9.35-21,.77-.69,1.58-1.36,2.42-2l0,.46,16.57-.79,1.2,25.39L21.83,42l0,1c-.11-.48-.21-1-.29-1.44A24.51,24.51,0,0,1,21.26,38.6Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.56,38.59c-.38-8,3.2-15.36,9.27-20.87q1.14-1,2.4-2V16l16.38-.78,1.2,25.39L22.12,42l.05,1c-.11-.47-.21-1-.29-1.43A24,24,0,0,1,21.56,38.59Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.86,38.57c-.37-7.89,3.17-15.22,9.2-20.69.75-.68,1.54-1.33,2.37-2V16l16.19-.77,1.2,25.39L22.42,42l0,.95c-.11-.47-.21-.95-.29-1.42A23.49,23.49,0,0,1,21.86,38.57Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.16,38.56c-.37-7.83,3.14-15.09,9.12-20.51a29.52,29.52,0,0,1,2.35-1.94c.41-.31.83-.61,1.26-.91l0,.73,14.7-.7,1.2,25.39L22.72,42l0,.9c-.11-.46-.2-.93-.28-1.4A23,23,0,0,1,22.16,38.56Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.46,38.54c-.36-7.75,3.12-14.95,9-20.32.74-.68,1.52-1.32,2.33-1.93.41-.31.82-.61,1.25-.9l0,.53,14.52-.69,1.2,25.39L23,41.93l0,.87c-.11-.46-.2-.92-.29-1.39A24.69,24.69,0,0,1,22.46,38.54Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.76,38.53c-.36-7.69,3.09-14.82,9-20.15a33.13,33.13,0,0,1,4.83-3.63l.05,1.1,13-.62,1.2,25.39-27.51,1.3,0,.83c-.1-.46-.2-.92-.28-1.38A24.18,24.18,0,0,1,22.76,38.53Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.07,38.52c-.36-7.62,3.05-14.7,8.87-20A32.58,32.58,0,0,1,36.73,15l0,.89,12.85-.61,1.2,25.39L23.61,41.9l0,.8c-.11-.45-.2-.91-.28-1.37A21.75,21.75,0,0,1,23.07,38.52Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.37,38.5C23,31,26.4,23.94,32.16,18.71a33.49,33.49,0,0,1,4.75-3.57l0,.69,12.68-.6,1.2,25.39L23.91,41.89l0,.76c-.11-.45-.2-.9-.28-1.36A21.26,21.26,0,0,1,23.37,38.5Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.67,38.49c-.35-7.48,3-14.43,8.71-19.61a32.75,32.75,0,0,1,4.71-3.54l0,.48,12.51-.59,1.2,25.39L24.21,41.88l0,.72q-.15-.68-.27-1.35A21.18,21.18,0,0,1,23.67,38.49Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,38.47C23.62,31.06,27,24.18,32.6,19a32.88,32.88,0,0,1,4.67-3.5v.28l12.34-.59,1.2,25.39L24.51,41.86l0,.68c-.11-.44-.2-.88-.27-1.33A20.69,20.69,0,0,1,24,38.47Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.27,38.46c-.34-7.34,2.95-14.16,8.56-19.25a31.4,31.4,0,0,1,4.61-3.47v.07l12.17-.58,1.2,25.39-26,1.23,0,.64c-.1-.43-.19-.88-.26-1.32A20.24,20.24,0,0,1,24.27,38.46Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.57,38.45c-.34-7.28,2.92-14,8.48-19.07a31.39,31.39,0,0,1,4.57-3.44l1.26-.75,0,.55,10.71-.51,1.2,25.39L25.1,41.83l0,.61c-.1-.43-.19-.87-.27-1.31A23.87,23.87,0,0,1,24.57,38.45Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.87,38.43c-.34-7.21,2.9-13.9,8.4-18.89a31,31,0,0,1,4.53-3.41c.82-.5,1.67-1,2.55-1.43l0,1,9.23-.44,1.2,25.39L25.4,41.82l0,.57c-.1-.43-.19-.86-.27-1.3A23.27,23.27,0,0,1,24.87,38.43Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.17,38.42c-.33-7.14,2.87-13.77,8.32-18.71A30.48,30.48,0,0,1,38,16.33q1.22-.75,2.52-1.41l0,.74,9.08-.43,1.2,25.39L25.7,41.81l0,.53c-.1-.43-.18-.86-.26-1.29A22.74,22.74,0,0,1,25.17,38.42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.48,38.4c-.34-7.07,2.83-13.63,8.23-18.53a31.14,31.14,0,0,1,4.45-3.34c.8-.5,1.63-1,2.49-1.4l0,.53,8.94-.43,1.2,25.39L26,41.79l0,.49c-.1-.42-.19-.84-.26-1.27A20.23,20.23,0,0,1,25.48,38.4Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.78,38.39c-.33-7,2.81-13.5,8.15-18.35a31,31,0,0,1,4.4-3.31c.8-.5,1.63-1,2.48-1.39v.31l8.8-.42,1.2,25.39L26.29,41.78l0,.45c-.09-.41-.18-.83-.25-1.26A20,20,0,0,1,25.78,38.39Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.08,38.37C25.75,31.44,28.86,25,34.15,20.2a31,31,0,0,1,4.36-3.27c.79-.49,1.61-.95,2.45-1.38v.09l8.65-.41,1.2,25.39L26.59,41.76l0,.42c-.1-.41-.18-.83-.25-1.25A19.65,19.65,0,0,1,26.08,38.37Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.38,38.36c-.32-6.86,2.76-13.24,8-18a31,31,0,0,1,9.32-5.78l0,.92,5.88-.28,1.2,25.39L26.89,41.75l0,.38c-.1-.41-.18-.82-.25-1.24A19.2,19.2,0,0,1,26.38,38.36Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.68,38.35c-.32-6.8,2.73-13.11,7.92-17.81a30.65,30.65,0,0,1,9.23-5.72l0,.69,5.76-.28,1.2,25.39L27.19,41.74v.34c-.09-.41-.18-.81-.25-1.23A20.55,20.55,0,0,1,26.68,38.35Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,38.33c-.31-6.72,2.7-13,7.84-17.63A30.57,30.57,0,0,1,44,15l0,.46,5.64-.27,1.2,25.39-23.34,1.1,0,.3c-.1-.39-.18-.8-.25-1.21A20.23,20.23,0,0,1,27,38.33Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.28,38.32C27,31.66,30,25.48,35,20.87a30.38,30.38,0,0,1,9-5.61v.23l5.53-.26,1.2,25.39-23,1.09V42c-.09-.39-.17-.79-.24-1.19A20.12,20.12,0,0,1,27.28,38.32Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.58,38.3c-.31-6.59,2.65-12.7,7.68-17.27a30.08,30.08,0,0,1,9-5.54h0l5.41-.26,1.2,25.39L28.08,41.69v.23c-.09-.39-.17-.79-.24-1.18A19.58,19.58,0,0,1,27.58,38.3Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.89,38.29c-.31-6.52,2.61-12.57,7.59-17.09a29.7,29.7,0,0,1,8.86-5.49c.84-.34,1.71-.65,2.59-.92l0,.57,2.66-.13,1.2,25.39L28.38,41.68v.19c-.1-.39-.17-.78-.24-1.17A17.58,17.58,0,0,1,27.89,38.29Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.19,38.27c-.31-6.45,2.59-12.44,7.51-16.91a29.75,29.75,0,0,1,8.77-5.43,32.69,32.69,0,0,1,5.25-1.61l-.1.91,1.2,25.39L28.67,41.67v.15c-.09-.39-.17-.77-.23-1.16A18.79,18.79,0,0,1,28.19,38.27Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.49,38.26c-.3-6.38,2.56-12.31,7.43-16.73a28.93,28.93,0,0,1,8.68-5.37,32,32,0,0,1,5.19-1.6l-.17.67,1.2,25.39L29,41.65v.12c-.09-.38-.17-.77-.24-1.15A20.51,20.51,0,0,1,28.49,38.26Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.79,38.25c-.3-6.32,2.54-12.18,7.36-16.55a28.57,28.57,0,0,1,8.57-5.32,31.65,31.65,0,0,1,5.14-1.58l-.24.43,1.2,25.39-21.55,1v.07c-.08-.37-.16-.75-.23-1.13A20,20,0,0,1,28.79,38.25Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.09,38.23c-.29-6.24,2.51-12,7.28-16.37a28.49,28.49,0,0,1,8.48-5.26A32,32,0,0,1,49.94,15l-.32.19,1.2,25.39-21.25,1v0c-.09-.37-.16-.74-.23-1.12A19.66,19.66,0,0,1,29.09,38.23Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.39,38.22C29.1,32,31.87,26.31,36.59,22A28,28,0,0,1,45,16.83a31.61,31.61,0,0,1,5-1.55l-.39,0,1.2,25.32-20.72,1,.06,1.1A19.1,19.1,0,0,1,29.39,38.22Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.69,38.2c-.28-6.1,2.46-11.78,7.12-16a27.8,27.8,0,0,1,8.3-5.14,31.89,31.89,0,0,1,5-1.53l-.44,0,1.18,25.07-20.42,1,.05,1.06A18.76,18.76,0,0,1,29.69,38.2Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,38.19c-.28-6,2.43-11.65,7-15.83a27.67,27.67,0,0,1,8.21-5.09,31.1,31.1,0,0,1,4.91-1.5l-.5,0,1.17,24.83-20.13,1,0,1A18.76,18.76,0,0,1,30,38.19Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.3,38.18c-.29-6,2.39-11.52,7-15.66a27.32,27.32,0,0,1,8.11-5A29.79,29.79,0,0,1,50.22,16l-.56,0,1.16,24.59L31,41.56l0,.95A18.33,18.33,0,0,1,30.3,38.18Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.6,38.16c-.28-5.9,2.37-11.38,6.87-15.47a27.06,27.06,0,0,1,8-5,29.85,29.85,0,0,1,4.81-1.47l-.63,0,1.15,24.34-19.54.92,0,.9A17.83,17.83,0,0,1,30.6,38.16Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.9,38.15c-.28-5.84,2.34-11.25,6.79-15.29a26.6,26.6,0,0,1,7.93-4.92,30.45,30.45,0,0,1,4.75-1.45l-.69,0,1.14,24.1-19.24.91,0,.85A17.5,17.5,0,0,1,30.9,38.15Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.2,38.13A19.2,19.2,0,0,1,37.92,23a26.12,26.12,0,0,1,7.83-4.85,28.7,28.7,0,0,1,4.69-1.44l-.75,0,1.13,23.86-18.95.9,0,.8A17.75,17.75,0,0,1,31.2,38.13Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.5,38.12a19,19,0,0,1,6.64-14.93,25.74,25.74,0,0,1,7.74-4.8A29,29,0,0,1,50.51,17l-.81,0,1.12,23.61-18.65.88,0,.75A17.76,17.76,0,0,1,31.5,38.12Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.8,38.1a18.76,18.76,0,0,1,6.56-14.75A25.63,25.63,0,0,1,46,18.62a28.46,28.46,0,0,1,4.59-1.41l-.87,0,1.1,23.37-18.36.87,0,.7A17.33,17.33,0,0,1,31.8,38.1Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.1,38.09a18.53,18.53,0,0,1,6.48-14.57,25,25,0,0,1,7.55-4.68,27.72,27.72,0,0,1,4.53-1.39l-.93,0,1.09,23.13-18.06.85,0,.65A16.83,16.83,0,0,1,32.1,38.09Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.4,38.08a18.35,18.35,0,0,1,6.4-14.4,25,25,0,0,1,7.46-4.62,28,28,0,0,1,4.47-1.37l-1,0,1.08,22.88-17.77.84,0,.6A17,17,0,0,1,32.4,38.08Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.71,38.06A18,18,0,0,1,39,23.85a24.48,24.48,0,0,1,7.37-4.56,27.24,27.24,0,0,1,4.41-1.36l-1,.05,1.07,22.64-17.47.83,0,.55A16.17,16.17,0,0,1,32.71,38.06Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,38.05a17.83,17.83,0,0,1,6.23-14,24.23,24.23,0,0,1,7.28-4.51,26.81,26.81,0,0,1,4.35-1.34l-1.11,0,1.06,22.4-17.17.81,0,.5A16.16,16.16,0,0,1,33,38.05Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.31,38a17.61,17.61,0,0,1,6.15-13.85,24.22,24.22,0,0,1,7.18-4.45c.69-.27,1.39-.52,2.11-.74.35-.11.72-.22,1.08-.31h0l1,21.94-16.88.8,0,.45A15.83,15.83,0,0,1,33.31,38Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.61,38a17.32,17.32,0,0,1,6.08-13.67A23.56,23.56,0,0,1,46.77,20c.68-.28,1.37-.52,2.08-.74.35-.11.71-.21,1.07-.3h-.13l1,21.7-16.58.78v.4A15.82,15.82,0,0,1,33.61,38Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.91,38a17.17,17.17,0,0,1,6-13.5,23.35,23.35,0,0,1,7-4.33c.67-.27,1.35-.51,2.05-.73l1.06-.3h-.2l1,21.46-16.29.77,0,.35A15.5,15.5,0,0,1,33.91,38Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.21,38a16.9,16.9,0,0,1,5.92-13.31A23.22,23.22,0,0,1,47,20.4c.65-.26,1.33-.5,2-.71.34-.11.69-.21,1-.3h-.27l1,21.22-16,.76v.3A15.66,15.66,0,0,1,34.21,38Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.51,38a16.74,16.74,0,0,1,5.84-13.14,22.79,22.79,0,0,1,6.81-4.21c.64-.26,1.31-.5,2-.71l1-.29h-.35l1,21-15.7.74v.25A15.16,15.16,0,0,1,34.51,38Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.81,38A16.47,16.47,0,0,1,40.57,25a22.61,22.61,0,0,1,6.71-4.16c.64-.26,1.3-.49,2-.7l1-.29-.43,0,1,20.74-15.4.73v.2A14.75,14.75,0,0,1,34.81,38Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.12,38a16.21,16.21,0,0,1,5.67-12.77,22.35,22.35,0,0,1,6.62-4.11c.63-.25,1.28-.48,1.94-.68l1-.29-.5,0,1,20.49-15.11.71v.15A14.25,14.25,0,0,1,35.12,38Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.42,37.93A16,16,0,0,1,41,25.34a22,22,0,0,1,6.53-4c.62-.25,1.26-.48,1.91-.68l1-.28-.58,0,1,20.25L36,41.32v.1A14.4,14.4,0,0,1,35.42,37.93Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.72,37.92a15.76,15.76,0,0,1,5.52-12.41,21.49,21.49,0,0,1,6.43-4c.61-.25,1.24-.47,1.88-.67.32-.1.65-.19,1-.27l-.66,0,1,20-14.52.69v0A14.15,14.15,0,0,1,35.72,37.92Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,37.91a15.54,15.54,0,0,1,5.44-12.24,21.33,21.33,0,0,1,6.34-3.93c.6-.24,1.22-.46,1.85-.65l1-.28-.72,0,.93,19.77-14,.66,0,.82c-.09-.27-.18-.54-.26-.81A13.67,13.67,0,0,1,36,37.91Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.32,37.89a15.29,15.29,0,0,1,5.36-12A20.72,20.72,0,0,1,47.93,22c.59-.24,1.2-.46,1.82-.65.32-.1.63-.19,1-.27l-.8,0,.92,19.53-13.7.65,0,.75c-.09-.26-.18-.52-.26-.79A14.24,14.24,0,0,1,36.32,37.89Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.62,37.88A15.11,15.11,0,0,1,41.9,26a20.52,20.52,0,0,1,6.15-3.81c.59-.23,1.19-.45,1.8-.64l.94-.26-.88,0,.91,19.29-13.41.63,0,.7c-.09-.26-.18-.52-.26-.79A14.25,14.25,0,0,1,36.62,37.88Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.92,37.86a14.84,14.84,0,0,1,5.2-11.69,20.26,20.26,0,0,1,6.06-3.76c.58-.23,1.17-.44,1.77-.62h0l.89,18.83-13.12.62,0,.63c-.09-.25-.18-.51-.26-.77A13.9,13.9,0,0,1,36.92,37.86Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.22,37.85a14.66,14.66,0,0,1,5.12-11.51,19.78,19.78,0,0,1,6-3.7c.57-.23,1.15-.44,1.75-.62h-.12l.88,18.6L38,41.23l0,.57c-.09-.25-.18-.51-.25-.76A13.57,13.57,0,0,1,37.22,37.85Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.53,37.83a14.38,14.38,0,0,1,5-11.33,19.57,19.57,0,0,1,5.88-3.64c.56-.22,1.13-.43,1.72-.61H50l.87,18.36-12.54.59,0,.51c-.09-.25-.17-.5-.25-.75A13.06,13.06,0,0,1,37.53,37.83Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.83,37.82a14.18,14.18,0,0,1,5-11.15,19.44,19.44,0,0,1,5.79-3.59,17.7,17.7,0,0,1,1.69-.59H50l.86,18.12-12.24.58,0,.44c-.09-.24-.17-.48-.25-.73A13.23,13.23,0,0,1,37.83,37.82Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.13,37.81a13.93,13.93,0,0,1,4.88-11,18.9,18.9,0,0,1,5.68-3.52c.54-.22,1.1-.42,1.67-.59l-.39,0,.85,17.88-11.7.55.05,1.11a13.06,13.06,0,0,1-1-4.47Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.43,37.79A13.7,13.7,0,0,1,43.23,27a18.65,18.65,0,0,1,5.59-3.47c.53-.21,1.08-.41,1.64-.58L50,23l.83,17.65-11.42.54.05,1a11.86,11.86,0,0,1-.51-1.41A12.39,12.39,0,0,1,38.43,37.79Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.73,37.78a13.51,13.51,0,0,1,4.72-10.62,18.34,18.34,0,0,1,5.5-3.4,14.62,14.62,0,0,1,1.61-.57l-.56,0,.82,17.41-11.13.53.05,1a11.43,11.43,0,0,1-.51-1.38A12.56,12.56,0,0,1,38.73,37.78Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39,37.76a13.25,13.25,0,0,1,4.64-10.43A18.08,18.08,0,0,1,49.08,24a16.4,16.4,0,0,1,1.58-.56l-.65,0,.81,17.17L40,41.13,40,42a12.23,12.23,0,0,1-.5-1.36A12.57,12.57,0,0,1,39,37.76Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.33,37.75A13,13,0,0,1,43.89,27.5a17.83,17.83,0,0,1,5.32-3.3c.5-.2,1-.39,1.55-.55l-.74,0,.8,16.93-10.55.5,0,.81a13.4,13.4,0,0,1-.48-1.34A11.65,11.65,0,0,1,39.33,37.75Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.63,37.74a12.82,12.82,0,0,1,4.48-10.08,17.39,17.39,0,0,1,5.22-3.23c.5-.2,1-.39,1.53-.55l-.83,0,.79,16.7-10.27.49,0,.73a10.41,10.41,0,0,1-.48-1.32A11.64,11.64,0,0,1,39.63,37.74Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.94,37.72a12.56,12.56,0,0,1,4.39-9.89,17,17,0,0,1,5.13-3.18c.49-.2,1-.37,1.5-.53l-.92,0,.78,16.46-10,.47,0,.66a11.68,11.68,0,0,1-.47-1.29A11.38,11.38,0,0,1,39.94,37.72Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.24,37.71A12.36,12.36,0,0,1,44.55,28a17.06,17.06,0,0,1,5-3.12c.48-.19,1-.36,1.47-.52l-1,0,.77,16.22-9.69.46,0,.58a9.5,9.5,0,0,1-.46-1.26A11.06,11.06,0,0,1,40.24,37.71Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.54,37.69a12.11,12.11,0,0,1,4.24-9.53,16.28,16.28,0,0,1,4.94-3.06c.47-.19,1-.36,1.44-.52l-1.1.06.76,16-9.4.45,0,.51A10.94,10.94,0,0,1,41,40.33,10.58,10.58,0,0,1,40.54,37.69Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.84,37.68A11.89,11.89,0,0,1,45,28.32a16.19,16.19,0,0,1,4.85-3l.7-.27-.47,0,.74,15.54-9.12.43,0,.44a11.13,11.13,0,0,1-.44-1.22A10.64,10.64,0,0,1,40.84,37.68Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.14,37.66a11.67,11.67,0,0,1,4.08-9.17A16,16,0,0,1,50,25.54l.69-.26-.56,0,.72,15.31L42,41l0,.36a12.26,12.26,0,0,1-.44-1.2A10.63,10.63,0,0,1,41.14,37.66Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.44,37.65a11.42,11.42,0,0,1,4-9,15.53,15.53,0,0,1,4.66-2.89l.68-.26-.67,0,.71,15.08L42.28,41v.28a11.61,11.61,0,0,1-.42-1.17A10.31,10.31,0,0,1,41.44,37.65Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.74,37.64a11.19,11.19,0,0,1,3.92-8.82A15.32,15.32,0,0,1,50.23,26h-.1l.69,14.63L42.57,41v.22a12.19,12.19,0,0,1-.42-1.15A10,10,0,0,1,41.74,37.64Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,37.62A11,11,0,0,1,45.88,29a15.19,15.19,0,0,1,4.48-2.78h-.22l.68,14.4-8,.38v.14A10.85,10.85,0,0,1,42.45,40,10,10,0,0,1,42,37.62Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.35,37.61a10.73,10.73,0,0,1,3.75-8.46,14.76,14.76,0,0,1,4.39-2.71h-.34l.67,14.17L43.14,41v.07a11.22,11.22,0,0,1-.41-1.1A9.63,9.63,0,0,1,42.35,37.61Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.65,37.59a10.51,10.51,0,0,1,3.67-8.27,14.37,14.37,0,0,1,4.29-2.66l-.45,0,.66,13.94L43.9,41,44,42A9.59,9.59,0,0,1,42.65,37.59Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,37.58a10.28,10.28,0,0,1,3.6-8.1,14.25,14.25,0,0,1,4.19-2.6l-.57,0,.65,13.71-6.65.32,0,.94A9.44,9.44,0,0,1,43,37.58Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.25,37.57a10.06,10.06,0,0,1,3.52-7.92,13.64,13.64,0,0,1,4.1-2.54l-.69,0,.64,13.48-6.37.3,0,.85A9.25,9.25,0,0,1,43.25,37.57Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.55,37.55A9.82,9.82,0,0,1,47,29.82a13.18,13.18,0,0,1,4-2.49l-.81,0,.63,13.25-6.09.29,0,.75A9.1,9.1,0,0,1,43.55,37.55Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.85,37.54A9.63,9.63,0,0,1,47.21,30a13.1,13.1,0,0,1,3.92-2.43l-.93.05.62,13L45,40.9l0,.65A8.87,8.87,0,0,1,43.85,37.54Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.15,37.52a9.37,9.37,0,0,1,3.28-7.37,12.69,12.69,0,0,1,3.82-2.37l-1,0,.61,12.79-5.54.26,0,.56A8.73,8.73,0,0,1,44.15,37.52Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.45,37.51a9.19,9.19,0,0,1,3.2-7.2A12.61,12.61,0,0,1,49.38,29c.31-.19.63-.37,1-.54h-.11l.58,12.15-5.26.25,0,.46A8.58,8.58,0,0,1,44.45,37.51Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.76,37.49a8.9,8.9,0,0,1,3.11-7,11.31,11.31,0,0,1,1.69-1.27c.3-.19.62-.36.94-.53h-.25l.57,11.93-5,.24,0,.36A8.18,8.18,0,0,1,44.76,37.49Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.06,37.48a8.65,8.65,0,0,1,3-6.84,11.22,11.22,0,0,1,1.63-1.23c.3-.18.61-.36.93-.52l-.39,0,.55,11.71-4.7.22v.27A8,8,0,0,1,45.06,37.48Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.36,37.47a8.46,8.46,0,0,1,3-6.66,11.22,11.22,0,0,1,1.59-1.2q.44-.27.9-.51l-.53,0,.54,11.49-4.43.21V41A7.84,7.84,0,0,1,45.36,37.47Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.66,37.45A8.19,8.19,0,0,1,48.54,31a10.67,10.67,0,0,1,1.55-1.17,9.25,9.25,0,0,1,.87-.49l-.67,0,.53,11.27-4.15.2v.07A7.58,7.58,0,0,1,45.66,37.45Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46,37.44a8,8,0,0,1,2.8-6.3A9.43,9.43,0,0,1,50.27,30c.27-.17.56-.33.85-.48l-.82,0,.52,11-3.43.16,0,.74a5.84,5.84,0,0,1-.48-.74A7.42,7.42,0,0,1,46,37.44Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.26,37.42A7.76,7.76,0,0,1,49,31.31a10.11,10.11,0,0,1,1.47-1.11h-.12l.49,10.41-3.16.15,0,.62a6.84,6.84,0,0,1-.47-.72A7.28,7.28,0,0,1,46.26,37.42Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.56,37.41a7.56,7.56,0,0,1,2.64-5.94,9.69,9.69,0,0,1,1.43-1.07l-.29,0,.48,10.2-2.9.14,0,.5a6.49,6.49,0,0,1-.46-.7A7.13,7.13,0,0,1,46.56,37.41Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.86,37.39a7.34,7.34,0,0,1,2.56-5.75,9.58,9.58,0,0,1,1.38-1l-.45,0,.47,10-2.15.1,0,1a6.73,6.73,0,0,1-.95-1.31A6.86,6.86,0,0,1,46.86,37.39Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.17,37.38a7.1,7.1,0,0,1,2.47-5.58,10.38,10.38,0,0,1,1.34-1l-.62,0,.46,9.79-1.9.09,0,.9A8,8,0,0,1,48,40.35,6.53,6.53,0,0,1,47.17,37.38Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.47,37.37a6.83,6.83,0,0,1,2.4-5.4,8.37,8.37,0,0,1,1.29-1l-.79,0,.45,9.59-1.65.08,0,.76a7,7,0,0,1-.9-1.22A6.38,6.38,0,0,1,47.47,37.37Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.77,37.35a6.58,6.58,0,0,1,2.32-5.21,9.13,9.13,0,0,1,1.25-.95l-1,0,.45,9.38-1.4.07,0,.62a7,7,0,0,1-.86-1.18A6.12,6.12,0,0,1,47.77,37.35Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.07,37.34a6.4,6.4,0,0,1,2.24-5,8,8,0,0,1,1.21-.91l-1.14.06.44,9.17-1.15.06,0,.48A6.51,6.51,0,0,1,48.86,40,5.84,5.84,0,0,1,48.07,37.34Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.37,37.32a6.13,6.13,0,0,1,2.16-4.85h-.1l.39,8.15-.9.05,0,.34a6.63,6.63,0,0,1-.81-1.1A5.69,5.69,0,0,1,48.37,37.32Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.67,37.31a6,6,0,0,1,2.08-4.68l-.31,0,.38,8-.65,0v.21a6,6,0,0,1-.77-1.06A5.43,5.43,0,0,1,48.67,37.31Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,37.3a5.72,5.72,0,0,1,2-4.5l-.52,0,.37,7.8.57,1A5.73,5.73,0,0,1,49,37.3Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.27,37.28A5.54,5.54,0,0,1,51.19,33l-.73,0,.36,7.62.77.78A5.5,5.5,0,0,1,49.27,37.28Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.58,37.27a5.25,5.25,0,0,1,1.83-4.14l-.94,0,.35,7.45,1,.59A5.2,5.2,0,0,1,49.58,37.27Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.88,37.25a4.52,4.52,0,0,1,.42-2.15,5.46,5.46,0,0,1,.56-1l-.35,0,.29,6.11h.35a5.14,5.14,0,0,1-.65-.9A4.55,4.55,0,0,1,49.88,37.25Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.18,37.24a4.39,4.39,0,0,1,.4-2.06h0l.19,4.07h0A4.39,4.39,0,0,1,50.18,37.24Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.48,37.22a4.2,4.2,0,0,1,.38-1.95h-.29l.18,3.87H51A4.24,4.24,0,0,1,50.48,37.22Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.23-4.73Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.21-4.48Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22,50.46,33Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.19-4Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.18-3.73Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.17-3.48Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22,50.5,34Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.14-3Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.13-2.74Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.12-2.49Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22,50.55,35Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.1-2Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.09-1.74Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l-.07-1.5Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22,50.6,36Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l0-1Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l0-.75Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l0-.5Z",
    transform: "translate(-3.08 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.66,37.22l0-.25Z",
    transform: "translate(-3.08 -1.12)"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.39 14.29 15.36 31.18 4.65 25.65 46.39 14.29"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.39 14.29 20.59 33.88 31.31 39.41 46.39 14.29"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.59 33.88 46.39 14.29 15.36 31.18 18.36 40.73 20.59 33.88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand-logo.34d2c7e3359f1d58a31f8da05266f19f.svg";
export { ForwardRef as ReactComponent };